import { CircularProgress } from "@mui/material";
import React, { ButtonHTMLAttributes } from "react";

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
    children: React.ReactNode;
    loading?: number;
};

const Button: React.FC<ButtonProps> = ({
    children,
    loading,
    type = "button",
    ...props
}: ButtonProps) => {
    return (
        <button {...props} type={type}>
            {loading === 1 ? (
                <CircularProgress style={{ color: "white" }} size={20} />
            ) : (
                children
            )}
        </button>
    );
};

export default Button;
